export const Glass = {
  pdf: {
    text: 'See the printable reference tool.',
    link: 'https://file.kbb.com/kbb/images/ico/conditionRedesign/exterior/20180719ConditionTool.pdf',
  },
  title: 'Examples of Damage',
  content: [
    {
      src: 'https://file.kbb.com/kbb/images/ico//conditionRedesign/glass/chips.png',
      title: 'Chips or Small Cracks',
      text: 'Glass breaks smaller than a quarter (less than 1 inch) caused by rocks, debris, or hail. Unless it obstructs the driver’s view, damage is often repairable.',
    },
    {
      src: 'https://file.kbb.com/kbb/images/ico//conditionRedesign/glass/cracks.png',
      title: 'Cracks',
      text: 'Glass breaks larger than a quarter (more than 1 inch) that start as chips and spread over time. Cracks that obstruct the driver’s view require replacement.',
    },
    {
      title: 'Previously Replaced with Factory Glass',
      text: 'Any windows, lights or mirrors that have been replaced with parts made by the manufacturer.',
    },
    {
      title: 'Previously Replaced with Non-Factory Glass',
      text: 'Any windows, lights or mirrors that have been replaced with parts from a 3rd party manufacturer.',
    },
    {
      src: 'https://file.kbb.com/kbb/images/ico//conditionRedesign/glass/headlights.png',
      title: 'Cloudy Headlights',
      text: 'Oxidation, or a fog that appears on headlights, caused over time by sunlight, road salt, pollution, and other environmental factors.',
    },
    {
      title: 'Damaged or Missing Glass',
      text: 'Cracks, damage, or any missing pieces to side mirrors, side glass, headlights, and/or taillights.',
    },
  ],
}
